/* Petizen About Us — scroll reveal only.
   The hero film autoplays via HTML attributes (autoplay muted loop playsinline);
   no film-placement or sound logic is needed in the Shopify build.
   Guarded so it initialises once even though several sections may include it. */
(function () {
  if (window.__pzAboutInit) return;
  window.__pzAboutInit = true;

  function reveal() {
    var items = document.querySelectorAll('.sr');
    if (!items.length) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('sr-visible'); io.unobserve(en.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      items.forEach(function (el) { io.observe(el); });
    } else {
      items.forEach(function (el) { el.classList.add('sr-visible'); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reveal);
  else reveal();
})();
